/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o={Relative:0,Absolute:1},e={ClipAtBoundary:0,RemoveIfCenterOutsideBoundary:1,DoNotTouchBoundary:2,DoNotClip:3};export{e as CIMPlacementClip,o as CIMSymbolUnits};
